var map = {
	"./Allergien.png": 838,
	"./Beruhigungsmittel_Schlafmittel.png": 839,
	"./Blase_Niere_Prostata.png": 840,
	"./Depression.png": 841,
	"./Erkältung.png": 842,
	"./Fieber.png": 843,
	"./Haut_Schleimhaut.png": 844,
	"./Husten.png": 845,
	"./Kopfschmerz.png": 846,
	"./Magen-Darm-Beschwerden.png": 847,
	"./Nahrungsergaenzungsmittel_Vitaminmangel.png": 848,
	"./Pflegeprodukte.png": 849,
	"./Pilzerkrankungen.png": 850,
	"./Schmerzen.png": 851,
	"./Schnupfen.png": 852,
	"./Schwindel.png": 853,
	"./Verhuetung.png": 854,
	"./Verletzung.png": 855,
	"./default.png": 856,
	"./default_grey.png": 857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 837;